import React, { useCallback, useEffect, useState } from "react";
import "./wallet.css";
import {
  Box,
  TextField,
  Typography,
  Button,
  CircularProgress,
  Avatar,
  FormHelperText,
  Grid,
} from "@mui/material";
import { debounce } from "lodash";
import { searchUser } from "../../DAL/fetch";
import { updateRcoin } from "../../DAL/update";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { enqueueSnackbar } from "notistack";
import { fileUrl } from "../../Config/Config";

const SendRcoins = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [searchLoading, setLoading] = useState(false);
  const [sendLoading, setSendLoading] = useState(false);
  const [type, setType] = useState(false);
  const [rcoins, setRcoins] = useState("");
  const [reason, setReason] = useState("");
  const [searchTerm, setSearchTerm] = useState([]);
  const [coinData, setCoinData] = useState("");

  const searchData = async () => {
    setLoading(true);

    try {
      const response = await searchUser({ codes: searchTerm });
      if (response && response.data) {
        setData(response.data.data || response.data);
      }
    } catch (error) {
      console.error("Search failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const debounceSearch = useCallback(
    debounce((query) => {
      setSearchTerm([...searchTerm, query]);
    }, 1000),
    []
  );

  const handleSearch = (e) => {
    setCoinData(e.target.value);
    debounceSearch(e.target.value);
  };
  useEffect(() => {
    if (searchTerm.length > 0 && searchTerm[0].length == 8) {
      searchData();
    }
  }, [searchTerm]);
  const handleRcoinsChange = (e) => {
    setRcoins(e.target.value);
  };
  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };
  const handleSendRcoins = async () => {
    if (data.length == 0) {
      setType(true);
      enqueueSnackbar("Please enter a correct RID",{variant:"error"})
      return;
    }
    if (!reason) {
      setType(true);
      enqueueSnackbar("Reason field required",{variant:"error"})
      return;
    }
    if (!rcoins || isNaN(rcoins) || Number(rcoins) <= 0) {
      setType(true);
      enqueueSnackbar("Please enter a valid number of Rcoin",{variant:"error"})
      return;
    }

    setSendLoading(true);
    try {
      const payload = { rcoin: Number(rcoins), reason: reason };
      const response = await updateRcoin(data[0].code, payload);

      if (response.status === 200) {
        enqueueSnackbar("RCoins sent successfully!", { variant: "success" });
        setRcoins("");
        navigate("/coins-history");
        setSearchTerm([]);
        setData("");
      }
    } catch (error) {
      console.error("Error sending RCoins:", error);
      enqueueSnackbar("An error occurred while sending RCoins.", {
        variant: "error",
      });
    } finally {
      setSendLoading(false);
    }
  };
  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };

  return (
    <>
      <div className="mainDiv">
        <ArrowBackIcon
          sx={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <div className="wallet-area">
          <div className="Wallet-form">
            <Typography variant="h5">
              <b>Send Rcoins</b>
            </Typography>
            {data[0]?.name && (
              <>
                <Avatar
                  alt={data[0]?.name}
                  src={
                    data[0]?.picture?.startsWith("http")
                                        ? data[0]?.picture
                                        : fileUrl + data[0]?.picture
                  }
                  sx={{ height: "100px", width: "100px", margin: "10px" }}
                />
                <Typography variant="h5">{data[0]?.name}</Typography>
              </>
            )}
            <Grid container spacing={2} sx={{ marginTop: 2 }}>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextField
                  fullWidth
                  placeholder="Enter RID *"
                  variant="outlined"
                  size="small"
                  type="number"
                  value={coinData}
                  onChange={handleSearch}
                  disabled={searchLoading}
                  sx={inputStyles}
                  InputLabelProps={{ sx: labelStyles }}
                />
                {type == true && data.length == 0 && (
                  <FormHelperText sx={{ color: "red" }}>
                    {"RID field is required"}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextField
                  fullWidth
                  placeholder="Enter Rcoins *"
                  variant="outlined"
                  size="small"
                  type="number"
                  value={rcoins}
                  onChange={handleRcoinsChange}
                  sx={inputStyles}
                  InputLabelProps={{ sx: labelStyles }}
                  inputProps={{ min: 1 }}
                />
                {type == true && !rcoins && (
                  <FormHelperText sx={{ color: "red" }}>
                    {"Rcoin field is required"}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextField
                  fullWidth
                  placeholder="Reason *"
                  variant="outlined"
                  size="small"
                  multiline
                  rows={3}
                  value={reason}
                  onChange={handleReasonChange}
                  sx={inputStyles}
                  InputLabelProps={{ sx: labelStyles }}
                />
                {type == true && !reason && (
                  <FormHelperText sx={{ color: "red" }}>
                    {"Reason is required"}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item lg={12}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSendRcoins}
                  className="gradientButton"
                  disabled={sendLoading || searchLoading}
                >
                  {sendLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Send Rcoins"
                  )}
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendRcoins;
